import {toast} from "react-toastify";

export const ThunksError = (error) => {
  console.error(error);
  toast.error("Une erreur s'est produite")
}